import { render, staticRenderFns } from "./Nominados.vue?vue&type=template&id=3b55ce2c&"
import script from "./Nominados.vue?vue&type=script&lang=js&"
export * from "./Nominados.vue?vue&type=script&lang=js&"
import style0 from "./Nominados.vue?vue&type=style&index=0&id=3b55ce2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports